import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { database } from "../../database/firebase";
import { ref, get, set } from "firebase/database";
import {
  SMART_TOURNAMENT_TYPE,
  SmartTournamentRules,
  KnockoutTournamentRules,
} from "./tournamentRules";
import "./rules.css";

function Rules({ updateHeader }) {
  const [adminRules, setAdminRules] = useState([]);
  const [matchType, setMatchType] = useState(null);
  const [tournamentType, setTournamentType] = useState("knockout");
  const [userData, setUserData] = useState(null);

  const isTournamentMode = matchType != null && matchType !== "live";
  const isSmartTournament = tournamentType === SMART_TOURNAMENT_TYPE;

  useEffect(() => {
    updateHeader({
      backButtonRedirect: "/login?save=true",
    });
  }, [updateHeader]);

  useEffect(() => {
    const stored = sessionStorage.getItem("userData");
    if (stored) setUserData(JSON.parse(stored));
  }, []);

  useEffect(() => {
    const themeRaw = sessionStorage.getItem("themeData");
    if (!themeRaw) return;
    try {
      const theme = JSON.parse(themeRaw);
      setAdminRules(Array.isArray(theme.rules) ? theme.rules : []);
    } catch (e) {
      setAdminRules([]);
    }
  }, []);

  useEffect(() => {
    if (!userData?.sessionId) return;

    const sessionMatchTypeRef = ref(
      database,
      `sessions/${userData.sessionId}/match_type`
    );

    const loadMatchType = async () => {
      try {
        const snap = await get(sessionMatchTypeRef);
        if (!snap.exists()) {
          await set(sessionMatchTypeRef, "live");
          setMatchType("live");
          return;
        }

        const value = snap.val();
        if (!value) {
          await set(sessionMatchTypeRef, "live");
          setMatchType("live");
        } else {
          setMatchType(value);
        }
      } catch (err) {
        console.error("Error checking session match_type", err);
        setMatchType("live");
      }
    };

    loadMatchType();
  }, [userData]);

  useEffect(() => {
    if (!isTournamentMode || !userData?.sessionId) return;

    const fetchTournamentType = async () => {
      try {
        const res = await fetch(
          process.env.REACT_APP_FOLDER_LINK + "/api/getTournamentList.php",
          {
            method: "POST",
            headers: { "Content-Type": "text/plain" },
            body: JSON.stringify({
              sessionId: userData.sessionId,
              userId: userData.userId,
            }),
          }
        );
        const data = await res.json();
        const firstTournament = (data.tournaments || [])[0];
        setTournamentType(firstTournament?.tournamentType || "knockout");
      } catch (err) {
        console.error("Error fetching tournament type", err);
        setTournamentType("knockout");
      }
    };

    fetchTournamentType();
  }, [isTournamentMode, userData]);

  const pageTitle = isTournamentMode
    ? isSmartTournament
      ? "Tournament Rules"
      : "Knockout Tournament — How to Play"
    : "Game Rules";

  return (
    <div className="ludo-rules-wrapper">
      <h1 className="ludo-rules-title">{pageTitle}</h1>
      <ol className="ludo-rules-list">
        {matchType == null ? null : isTournamentMode ? (
          isSmartTournament ? (
            <SmartTournamentRules />
          ) : (
            <KnockoutTournamentRules />
          )
        ) : (
          adminRules.map((text, i) => <li key={i}>{text}</li>)
        )}
      </ol>
      <Link to="/tournament-page" className="ludo-rules-next">
        Next
      </Link>
    </div>
  );
}

export default Rules;
